<script lang="ts">
    import { Component, Emit, mixins, Prop } from 'vue-facing-decorator';
    import IconComponent from '@/components/atoms/Icon.vue';
    import { ITranslationData } from "webshop-modules/translation/translation-data.definition";
    import { IconName } from "webshop-modules";
    import { BreakpointHandler } from "@/mixins";

    @Component({
        name: 'ActionButtonComponent',
        components: {IconComponent}
    })
    export default class ActionButtonComponent extends mixins(BreakpointHandler) {

        @Prop()
        public label: ITranslationData | string | undefined;

        @Prop()
        public iconName: IconName | undefined;


        @Emit()
        public clicked(event: Event): Event {
            return event;
        }

        public get isTranslationLabel(): boolean {
            return this.label !== undefined && typeof this.label !== 'string';
        }
    }
</script>

<template>
    <button class="m-actionButton" v-on:click.stop="clicked">
        <span class="m-actionButton__iconContainer">
            <IconComponent class="m-actionButton__icon" :icon-id="iconName"/>
        </span>
        <span v-if="isTranslationLabel"
              v-bind:class="{'smaller-width': isGadget }"
              v-translate="label"
              class="m-actionButton__text"></span>
        <span v-else v-bind:class="{'smaller-width': isGadget }" v-html="label" class="m-actionButton__text"></span>
    </button>
</template>
